import { useEffect, useState } from "react";
import { api } from "../api.ts";
import { fmtDateTime } from "../labels.ts";

export function ExecutionHistory(props: { customerId: string; version: number; onChanged: () => void }): React.JSX.Element {
  const [rows, setRows] = useState<{ id: string; label: string; level: number; createdAt: string; undone: boolean; undoable: boolean }[]>([]);
  const [err, setErr] = useState("");
  useEffect(() => {
    const load = () => { void api.get<{ executions: typeof rows }>(`/api/customers/${props.customerId}/executions`)
      .then((r) => setRows(r.executions)).catch((e) => setErr((e as Error).message)); };
    load();
    const timer = setInterval(() => { if (document.visibilityState === "visible") load(); }, 8000);
    return () => clearInterval(timer);
  }, [props.customerId, props.version]);
  const undo = async (id: string): Promise<void> => {
    try { await api.post(`/api/executions/${id}/undo`); props.onChanged(); } catch (e) { setErr((e as Error).message); }
  };
  return <section className="card"><div className="secttl">AI 执行记录与撤销</div>
    {err && <p className="err">{err}</p>}
    {rows.length === 0 ? <p className="muted">还没有 AI 执行记录。</p> : <div className="table-scroll"><table className="tbl"><tbody>
      {rows.map((r) => <tr key={r.id}><td>{r.label} · L{r.level}<div className="muted">{fmtDateTime(r.createdAt)}</div></td>
        <td>{r.undone ? "已撤销" : r.undoable ? <button className="b sm" onClick={() => void undo(r.id)}>撤销</button> : "已留痕"}</td></tr>)}
    </tbody></table></div>}
  </section>;
}
